import classNames from "classnames";
import {
  useMemo,
  type CSSProperties,
  type ChangeEvent as ReactChangeEvent,
  type RefObject,
} from "react";
import styles from "./Input.module.css";

type TextInputRef = RefObject<HTMLInputElement>;
type TextAreaRef = RefObject<HTMLTextAreaElement>;

type ChangeEvent = ReactChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

interface Props {
  id?: string;
  name?: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  onBlur?: (e: ChangeEvent) => void;
  multiline?: boolean;
  placeholder?: string;
  inputRef?: TextInputRef | TextAreaRef;
  onChange?: (e: ChangeEvent) => void;
  value?: string;
  error?: string;
  style?: CSSProperties;
}

export default function Input({
  type = "text",
  multiline,
  error,
  style,
  ...props
}: Props) {
  const className = useMemo(
    () => classNames(styles.Input, { [styles.Error]: !!error }),
    [error],
  );
  return (
    <div style={{ position: "relative", width: "100%", ...style }}>
      {multiline ? (
        <textarea className={className} {...props} />
      ) : (
        <input className={className} type={type} {...props} />
      )}
      {error && (
        <div
          style={{
            position: "absolute",
            background: "white",
            fontSize: 12,
            color: "red",
            bottom: -8,
            left: 12,
            display: "flex",
            alignItems: "center",
          }}
        >
          <svg
            aria-hidden="true"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            focusable="false"
            style={{ marginRight: 4, flexShrink: 0 }}
          >
            <path d="M1 21h22L12 2 1 21z" fill="red" />
            <path
              d="M12 9v5"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
            />
            <circle cx={12} cy={17} r={1} fill="white" />
          </svg>
          {error}
        </div>
      )}
    </div>
  );
}
